import { WorkflowLearningStage } from 'api-clients/monolith';
import React, { VFC } from 'react';
import { useSelector } from 'react-redux';

import { makeUniversalRecruiterDashboardEnabled } from 'containers/Auth_old/selectors';
import { ReviewStage } from 'containers/WorkflowEditor/components/ReviewStage';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';

import { IdleMoveRule } from '../../../IdleMoveRule';
import { StageSettingMessageCard } from '../../../StageSettingMessageCard';
import { IntegrationCard } from './IntegrationCard';

export const LearningStage: VFC<{ stage: WorkflowLearningStage }> = ({
  stage,
}) => {
  const universalRecruiterDashboardEnabled = useSelector(
    makeUniversalRecruiterDashboardEnabled(),
  );

  return (
    <div data-testid="lessonlyStage">
      {universalRecruiterDashboardEnabled && (
        <StageSection>
          <ReviewStage stage={stage} />
        </StageSection>
      )}
      <StageSection>
        <IntegrationCard stage={stage} />
      </StageSection>
      <StageSection>
        <IdleMoveRule stage={stage} />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="learning"
          stageExternalId={stage.external_id}
        />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="trigger"
          stageExternalId={stage.external_id}
        />
      </StageSection>
    </div>
  );
};
